import React from "react";
import {HeaderTenkenMenu, HeaderTenkenTitle, HeaderUsersMenu, HeaderUsersTitle, SpanEnv} from "../../components";

const Header = (props) => {
    const {app = "tenken"} = props;
    const headerBackground = (app === "tenken") ? "bg-[#111D3A]" : "bg-[#1D1D1D]";
    const headerClass = `flex justify-between py-[12px] px-[24px] relative ${headerBackground}`;

    return (
        <header className={headerClass}>
            <SpanEnv className="top-[12px]"/>
            {app === "tenken" ? <HeaderTenkenTitle /> : <HeaderUsersTitle />}
            {app === "tenken" ? <HeaderTenkenMenu /> : <HeaderUsersMenu />}
        </header>
    );
};

export default Header;
